export type TransactionAnalyticsClass = 'normal' | 'extraordinary' | 'investment' | 'transfer' | 'ignored'

export const analyticsClassLabels: Record<TransactionAnalyticsClass, string> = {
	normal: 'Ordinario',
	extraordinary: 'Extraordinario',
	investment: 'Inversión',
	transfer: 'Transferencia',
	ignored: 'Ignorado',
}

export const effectiveAnalyticsClass = (analyticsClass?: TransactionAnalyticsClass): TransactionAnalyticsClass => (
	analyticsClass || 'normal'
)

export const isExcludedFromOrdinaryAnalytics = (analyticsClass?: TransactionAnalyticsClass): boolean => (
	effectiveAnalyticsClass(analyticsClass) !== 'normal'
)

export const appendAnalyticsChartFilter = (params: URLSearchParams, includeNonNormalAnalytics: boolean) => {
	if (includeNonNormalAnalytics) {
		params.set('includeNonNormalAnalytics', 'true')
	}
}
